export const inspection = [
  { path: 'created', title: 'Creación', icon: 'mdi-calendar-blank-outline' },
  { path: 'client.name', title: 'Cliente', icon: 'mdi-account' },
]
